import { EnumErrorStates, ErrorObject } from '@inmoment/the-kitchen';

export class ErrorObjectUtils {
  public static create(
    state: EnumErrorStates = EnumErrorStates.SUCCESS,
    text?: string
  ): ErrorObject {
    return {
      state,
      text,
    };
  }

  public static setWarning(errorObject: ErrorObject, text: string): ErrorObject {
    errorObject.state = EnumErrorStates.WARNING;
    errorObject.text = text;
    return errorObject;
  }

  public static setError(errorObject: ErrorObject, text: string): ErrorObject {
    errorObject.state = EnumErrorStates.ERROR;
    errorObject.text = text;
    return errorObject;
  }

  public static setNoError(errorObject: ErrorObject): ErrorObject {
    errorObject.state = EnumErrorStates.SUCCESS;
    errorObject.text = '';
    return errorObject;
  }

  public static setSuccess(errorObject: ErrorObject): ErrorObject {
    errorObject.state = EnumErrorStates.SUCCESS;
    errorObject.text = '';
    return errorObject;
  }

  public static hasError(errorObject: ErrorObject): boolean {
    return errorObject.state === EnumErrorStates.ERROR;
  }
}
